import { render, staticRenderFns } from "./PedidoCardMobile.vue?vue&type=template&id=6fd232e2&scoped=true"
import script from "./PedidoCardMobile.vue?vue&type=script&lang=js"
export * from "./PedidoCardMobile.vue?vue&type=script&lang=js"
import style0 from "./PedidoCardMobile.vue?vue&type=style&index=0&id=6fd232e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd232e2",
  null
  
)

export default component.exports